import { HOTLINE_REQUEST_STATUS_CANCELED, HOTLINE_REQUEST_STATUS_COMPLETED, } from '@/feature/hotline/client/constant/requestStatus';
import { HOTLINE_MESSAGE_STATUS_RECEIVED } from '@/feature/hotline/constant/messageStatus';
import { isNotEmptyNumber } from '@/utils/checkValue/number';
import { formatUploadedFiles } from '@/utils/form/file';
/**
 * チャットを送信するクライアントユーザーの情報を整形する
 */
export const formatClientChatUser = (profile) => ({
    clientId: `${profile.id}`,
    firstName: 'あなた',
    isShowDetailPage: false,
    lastName: '',
});
/**
 * チャットを送信するコンサルユーザーの情報を整形する
 */
export const formatProfessionalChatUser = (profile) => ({
    firstName: profile.information.firstName,
    imageSrc: profile.information.file,
    isShowDetailPage: false,
    lastName: profile.information.lastName,
});
/**
 * メッセージの情報を整形する
 *
 * @param messages メッセージ一覧
 * @param isProfessionalPage コンサル側ページからの呼び出しか
 */
export const formatChatMessages = (messages, isProfessionalPage) => messages.map((message) => {
    var _a, _b;
    const clientUser = {
        clientId: isNotEmptyNumber(message.client_id)
            ? message.client_id.toString()
            : '',
        firstName: isProfessionalPage ? 'クライアント企業担当者より' : 'あなた',
        isRetired: message.is_retired,
        isShowDetailPage: false,
        lastName: '',
        professionalId: '',
    };
    const professionalUser = {
        clientId: '',
        firstName: message.first_name,
        imageSrc: (_a = message.image_src) !== null && _a !== void 0 ? _a : undefined,
        isRetired: message.is_retired,
        isShowDetailPage: message.has_professional_detail_page,
        lastName: message.last_name,
        professionalId: isNotEmptyNumber(message.professional_id)
            ? message.professional_id.toString()
            : '',
        professionalType: (_b = message.professional_type) !== null && _b !== void 0 ? _b : undefined,
    };
    return {
        message: {
            files: message.files.map((file) => ({
                id: file.hotline_request_message_file_id,
                name: file.name,
            })),
            isBox: !message.is_self,
            message: message.message || '',
            messageId: message.id,
            time: message.published_at,
            unread: message.is_unread,
        },
        user: message.is_client ? clientUser : professionalUser,
    };
});
/**
 * 一覧データの情報を整形する
 */
export const formatListItems = (hotlineRequests, selectedId, clipList, cancelTargetIds) => hotlineRequests
    .map((hotlineRequest) => ({
    checked: cancelTargetIds.includes(hotlineRequest.id),
    companyName: hotlineRequest.professional.professional_organization_name,
    disabledCheck: HOTLINE_REQUEST_STATUS_COMPLETED.value === hotlineRequest.status ||
        HOTLINE_REQUEST_STATUS_CANCELED.value === hotlineRequest.status,
    hasUnAnswer: !hotlineRequest.is_message_closed &&
        hotlineRequest.message_status === HOTLINE_MESSAGE_STATUS_RECEIVED.value,
    id: hotlineRequest.id,
    isClipped: clipList.includes(hotlineRequest.id),
    isSelected: hotlineRequest.id === selectedId,
    lastMessagePublishedAt: hotlineRequest.last_message_published_at,
    unReadCount: hotlineRequest.unread_count,
}))
    // 並び替え
    .sort((a, b) => {
    if (a.isClipped !== b.isClipped) {
        // クリップ済みを優先表示
        return a.isClipped ? -1 : 1;
    }
    // 最終メッセージ順に並び替え
    const dateA = a.lastMessagePublishedAt
        ? new Date(a.lastMessagePublishedAt).getTime()
        : 0;
    const dateB = b.lastMessagePublishedAt
        ? new Date(b.lastMessagePublishedAt).getTime()
        : 0;
    return dateB - dateA;
});
/**
 * メッセージ送信用のデータを整形する
 */
export const formatSendMessageData = (formValues) => ({
    files: formatUploadedFiles(formValues === null || formValues === void 0 ? void 0 : formValues.files),
    message: formValues.description,
});
